// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*   muted country boundaries */
.em--coxcomb .em-cntbn {
    stroke: grey;
    stroke-width: 0.25px;
}

/* Coastlines should not be drawn for choropleths, however for prop symbol maps with white regions they can be necessary */
.em--ps .em-bn-co,
.em--pie .em-bn-co {
    stroke: grey;
    stroke-width: 0.1px;
}

/*  regions without data input */
.em--coxcomb [ecl='ni'] {
    fill: #e9e9e9;
}

/* Default region fill */
.em--coxcomb .em-cntrg,
.em--coxcomb .em-nutsrg {
    fill: #fafcde;
}

.em--coxcomb #em-cntbn-halo {
    stroke: none;
}
`, "",{"version":3,"sources":["webpack://./src/css/map-types/coxcomb.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA,0HAA0H;AAC1H;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,aAAa;AACjB;;AAEA,wBAAwB;AACxB;;IAEI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/*   muted country boundaries */\r\n.em--coxcomb .em-cntbn {\r\n    stroke: grey;\r\n    stroke-width: 0.25px;\r\n}\r\n\r\n/* Coastlines should not be drawn for choropleths, however for prop symbol maps with white regions they can be necessary */\r\n.em--ps .em-bn-co,\r\n.em--pie .em-bn-co {\r\n    stroke: grey;\r\n    stroke-width: 0.1px;\r\n}\r\n\r\n/*  regions without data input */\r\n.em--coxcomb [ecl='ni'] {\r\n    fill: #e9e9e9;\r\n}\r\n\r\n/* Default region fill */\r\n.em--coxcomb .em-cntrg,\r\n.em--coxcomb .em-nutsrg {\r\n    fill: #fafcde;\r\n}\r\n\r\n.em--coxcomb #em-cntbn-halo {\r\n    stroke: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
